module.exports = __webpack_public_path__ + "img/login.2ea3d3f1.png";